import { JSX } from "react";
import {
    Admin,
    Resource,
} from "react-admin";
import {
    Business,
    Phone,
    Link,
    Language,
    AdminPanelSettings,
    Person4,
    Email,
    ContactMail,
    Share,
    EmojiPeople,
    Badge,
    LocationCity,
    Apartment,
    Group,
    DocumentScanner,
    Person,
    SupervisorAccount,
    History,
    ReportProblem
} from '@mui/icons-material';

import authProvider from "../providers/provider/authProvider";
import { AdminLayout } from './layouts/AdminLayout';
import { hqDarkTheme, hqLightTheme } from '../styles/theme/hqTheme';

import { dataProvider } from '../providers/provider/dataProvider'

import LoginForm from "./user/LoginForm";

import { AdminAddressesList } from "./lists/AdminAddressList";
import { AdminAddressEdit } from "./edit/AdminAddressEdit";
import { AdminAddressShow } from "./show/AdminAddressShow";
import { AdminAddressCreate } from "./create/AdminAddressCreate";

import { AdminUserList } from "./lists/AdminUserList";
import { AdminUserCreate } from "./create/AdminUserCreate";
import { AdminRoleList } from "./lists/AdminRoleList";
import { AdminRoleCreate } from "./create/AdminRoleCreate";
import { AdminRoleEdit } from "./edit/AdminRoleEdit";
import { AdminUserEdit } from "./edit/AdminUserEdit";

import { AdminCompanyList } from "./lists/AdminCompanyList";
import { AdminCompanyEdit } from "./edit/AdminCompanyEdit";
import { AdminCompanyCreate } from "./create/AdminCompanyCreate";

import { AdminCompanyHouseList } from "./lists/AdminCompaniesHouseList";
import { AdminCompaniesHouseEdit } from "./edit/AdminCompaniesHouseEdit";
import { AdminCompaniesHouseShow } from "./show/AdminCompaniesHouseShow";
import { AdminCompaniesHouseCreate } from "./create/AdminCompaniesHouseCreate";

import { AdminCompaniesHouseAddressesList } from "./lists/AdminCompaniesHouseAddressList";
import { AdminCompaniesHouseAddressEdit } from "./edit/AdminCompaniesHouseAddressEdit";
import { AdminCompaniesHouseAddressShow } from "./show/AdminCompaniesHouseAddressShow";
import { AdminCompaniesHouseAddressCreate } from "./create/AdminCompaniesHouseAddressCreate";

import { AdminCompaniesHouseFilingHistoryList } from "./lists/AdminCompaniesHouseFilingHistoryList";
import { AdminCompaniesHouseFilingHistoryEdit } from "./edit/AdminCompaniesHouseFilingHistoryEdit";
import { AdminCompaniesHouseFilingHistoryCreate } from "./create/AdminCompaniesHouseFilingHistoryCreate";
import { AdminCompaniesHouseFilingHistoryShow } from "./show/AdminCompaniesHouseFilingHistoryShow";

import { AdminCompaniesHousePeopleList } from "./lists/AdminCompaniesHousePeopleList";
import { AdminCompaniesHousePeopleEdit } from "./edit/AdminCompaniesHousePeopleEdit";
import { AdminCompaniesHousePeopleShow } from "./show/AdminCompaniesHousePeopleShow";
import { AdminCompaniesHousePeopleCreate } from "./create/AdminCompaniesHousePeopleCreate";

import { AdminEmailList } from "./lists/AdminEmailList";
import { AdminEmailEdit } from "./edit/AdminEmailEdit";
import { AdminEmailShow } from "./show/AdminEmailShow";
import { AdminEmailCreate } from "./create/AdminEmailCreate";

import { AdminEmployeeList } from "./lists/AdminEmployeeList";
import { AdminEmployeeEdit } from "./edit/AdminEmployeeEdit";
import { AdminEmployeeShow } from "./show/AdminEmployeeShow";
import { AdminEmployeeCreate } from "./create/AdminEmployeeCreate";

import { AdminPeopleList } from "./lists/AdminPeopleList";
import { AdminPeopleCreate } from "./create/AdminPeopleCreate";
import { AdminPeopleEdit } from "./edit/AdminPeopleEdit";
import { AdminPeopleShow } from "./show/AdminPeopleShow";

import { AdminSocialList } from "./lists/AdminSocialList";
import { AdminSocialEdit } from "./edit/AdminSocialEdit";
import { AdminSocialShow } from "./show/AdminSocialShow";
import { AdminSocialCreate } from "./create/AdminSocialCreate";

import { AdminTelephoneList } from "./lists/AdminTelephoneList";
import { AdminTelephoneEdit } from "./edit/AdminTelephoneEdit";
import { AdminTelephoneShow } from "./show/AdminTelephoneShow";
import { AdminTelephoneCreate } from "./create/AdminTelephoneCreate";

import { AdminUrlList } from "./lists/AdminUrlList";
import { AdminUrlEdit } from "./edit/AdminUrlEdit";
import { AdminUrlShow } from "./show/AdminUrlShow";
import { AdminUrlCreate } from "./create/AdminUrlCreate";

import { AdminWebsiteList } from "./lists/AdminWebsiteList";
import { AdminWebsiteEdit } from "./edit/AdminWebsiteEdit";
import { AdminWebsiteShow } from "./show/AdminWebsiteShow";

import { SettingsList } from "./lists/SettingsList";
import { SettingsEdit } from "./edit/SettingsEdit";
import { SettingsCreate } from "./create/SettingsCreate";

import { OperatorList } from "./lists/OperatorList";
import { OperatorCreate } from "./create/OperatorCreate";
import { OperatorEdit } from "./edit/OperatorEdit";

import { WorkflowList } from "./lists/WorkflowList";
import { WorkflowCreate } from "./create/WorkflowCreate";
import { WorkflowEdit } from "./edit/WorkflowEdit";

import { PromptList } from "./lists/PromptList";
import { PromptCreate } from "./create/PromptCreate";
import { PromptEdit } from "./edit/PromptEdit";

import { AdminAiSystemAgentToolList } from "./lists/AdminAiSystemAgentToolList";
import { AdminAiSystemAgentToolCreate } from "./create/AdminAiSystemAgentToolCreate";
import { AdminAiSystemAgentToolEdit } from "./edit/AdminAiSystemAgentToolEdit";

import { ModelSchemaCreate } from "./create/ModelSchemaCreate";
import { ModelSchemaList } from "./lists/ModelSchemaList";
import { ModelSchemaEdit } from "./edit/ModelSchemaEdit";
import { LlmModelPriceCreate } from "./create/LlmModelPriceCreate";
import { LlmModelPriceList } from "./lists/LlmModelPriceList";
import { LlmModelPriceEdit } from "./edit/LlmModelPriceEdit";

import { NokWebsiteList } from "./lists/NokWebsiteList";
import { NokWebsiteEdit } from "./edit/NokWebsiteEdit";
import { NokWebsiteCreate } from "./create/NokWebsiteCreate";

import { NokPersonaList } from "./lists/NokPersonaList";
import { NokPersonaCreate } from "./create/NokPersonaCreate";
import { NokPersonaEdit } from "./edit/NokPersonaEdit";

import { NokEmailSignatureList } from "./lists/NokEmailSignatureList";
import { NokEmailSignatureEdit } from "./edit/NokEmailSignatureEdit";
import { NokEmailSignatureCreate } from "./create/NokEmailSignatureCreate";

import { NokEmailTemplateList } from "./lists/NokEmailTemplateList";
import { NokEmailTemplateEdit } from "./edit/NokEmailTemplateEdit";
import { NokEmailTemplateCreate } from "./create/NokEmailTemplateCreate";

import { DashboardContainer } from "./dashboard/DashboardContainer";
import { WhatsNewPage } from "./whats-new/WhatsNewPage";
import { MaintenancePage } from "./maintenance/MaintenancePage";
import { HqApiQueuesPage } from "./queues/HqApiQueuesPage";
import { CustomRoutes } from 'react-admin';
import { Navigate, Route, useParams } from 'react-router-dom';

/** Sends a stale company Show link to the merged company screen. */
const RedirectToCompanyEdit: () => JSX.Element = (): JSX.Element => {
    const { id } = useParams();

    return <Navigate to={ '/companies/' + id } replace />;
}

import { TokenHistoryList } from "./lists/TokenHistoryList";

import { CmsBlockList } from "./lists/CmsBlockList";
import { CmsBlockCreate } from "./create/CmsBlockCreate";
import { CmsBlockEdit } from "./edit/CmsBlockEdit";

import { NokMiniList } from "./lists/NokMiniList";
import { NokMiniCreate } from "./create/NokMiniCreate";
import { NokMiniEdit } from "./edit/NokMiniEdit";

import { CustomerList } from "./lists/CustomerList";
import { CustomerEdit } from "./edit/CustomerEdit";

import { CustomerAccountList } from "./lists/CustomerAccountList";
import { CustomerAccountCreate } from "./create/CustomerAccountCreate";
import { CustomerAccountEdit } from "./edit/CustomerAccountEdit";
import { CustomerActivityMonitorList } from "./lists/CustomerActivityMonitorList";

import { CustomerAddressEdit } from "./edit/CustomerAddressEdit";

import { SubscriptionList } from "./lists/SubscriptionList";

import { SubscriptionProductList } from "./lists/SubscriptionProductList";
import { SubscriptionProductCreate } from "./create/SubscriptionProductCreate";
import { SubscriptionProductEdit } from "./edit/SubscriptionProductEdit";

import { SubscriptionProductPriceList } from "./lists/SubscriptionProductPriceList";
import { SubscriptionProductPriceCreate } from "./create/SubscriptionProductPriceCreate";
import { SubscriptionProductPriceEdit } from "./edit/SubscriptionProductPriceEdit";

import { SubscriptionInvoiceList } from "./lists/SubscriptionInvoiceList";
import { SubscriptionInvoiceShow } from "./show/SubscriptionInvoiceShow";

import { CouponsList } from "./lists/CouponsList";
import { CouponCreate } from "./create/CouponCreate";
import { CouponShow } from "./show/CouponShow";

import { EmailFinderList } from "./lists/EmailFinderList";
import { EmailFinderEdit } from "./edit/EmailFinderEdit";

import { EmailFinderResultsList } from "./lists/EmailFinderResultsList";
import { EmailFinderResultsEdit } from "./edit/EmailFinderResultsEdit";

import { EnterpriseRequestsList } from "./lists/EnterpriseRequestsList";
import { EnterpriseRequestCreate } from "./create/EnterpriseRequestCreate";
import { EnterpriseRequestEdit } from "./edit/EnterpriseRequestEdit";

import { CustomerTutorialList } from "./lists/CustomerTutorialList";
import { CustomerTutorialCreate } from "./create/CustomerTutorialCreate";
import { CustomerTutorialEdit } from "./edit/CustomerTutorialEdit";

import { SalesConversationList } from './lists/SalesConversationList';
import { ContactFormList } from "./lists/ContactFormList";
import { ContactFormEdit } from "./edit/ContactFormEdit";

import { MysteryShopperList } from "./lists/MysteryShopperList";
import { MysteryShopperEdit } from "./edit/MysteryShopperEdit";

import { MysteryShoppersResultsList } from "./lists/MysteryShopperResultsList";
import { NokProcessingFailuresList } from "./lists/NokProcessingFailuresList";
import { MysteryShoppersResultsEdit } from "./edit/MysteryShopperResultsEdit";

import { SubscriptionRefundList } from "./lists/SubscriptionRefundList";
import { SubscriptionRefundShow } from "./show/SubscriptionRefundShow";

import { EmailMessagesEdit } from "./edit/EmailMessagesEdit";
import { EmailMessagesList } from "./lists/EmailMessagesList";
import { EmailMessagesShow } from "./show/EmailMessagesShow";

import { ComplianceSnifferList } from "./lists/ComplianceSnifferList";
import { ComplianceSnifferEdit } from "./edit/ComplianceSnifferEdit";

import { NokList } from "./lists/NokList";
import { NokCreate } from "./create/NokCreate";
import { NokEdit } from "./edit/NokEdit";

import { MiniGradesList } from "./lists/MiniGradesList";
import { MiniGradeEdit } from "./edit/MiniGradeEdit";

import { MiniResultsList } from "./lists/MiniResultsList";
import { MiniResultEdit } from "./edit/MiniResultEdit";

import { ComplianceSnifferResultsList } from "./lists/ComplianceSnifferResultsList";
import { ComplianceSnifferResultsEdit } from "./edit/ComplianceSnifferResultsEdit";

const AdminApp: () => JSX.Element = (): JSX.Element => {

    return (
        <Admin
            theme={ hqLightTheme }
            darkTheme={ hqDarkTheme }
            dataProvider={ dataProvider }
            layout={ AdminLayout }
            authProvider={ authProvider }
            loginPage={ LoginForm }
            dashboard={ DashboardContainer }
        >
            { /* The company Show screen was merged into its Edit on 2026-09-10 and its route
                 removed. Without this, an old `/companies/12/show` link is read as the edit
                 screen's tab route with a tab named "show": react-admin mounts the form, MUI
                 refuses the tab value, and the screen renders its chrome and nothing else. A
                 stale bookmark lands on the merged screen instead. */ }
            <CustomRoutes>
                <Route path="/companies/:id/show" element={ <RedirectToCompanyEdit /> } />
                { /* The production change log, for every signed-in admin. */ }
                <Route path="/whats-new" element={ <WhatsNewPage /> } />
                { /* Maintenance windows. Every admin may look; the controls need HQ_System::maintenance. */ }
                <Route path="/maintenance" element={ <MaintenancePage /> } />
                { /* HQ-API's queues, schedules and backlogs. Gated by HQ-API on HQ_System::queues:
                     a CustomRoutes page is not covered by ACL_RESOURCES, so the refusal from
                     GET /hq/queues is what a role without it sees. */ }
                <Route path="/system-queues" element={ <HqApiQueuesPage /> } />
            </CustomRoutes>
            {/*  ADMIN USERS */}
            <Resource
                name="admin_users"
                list={ AdminUserList }
                create={ AdminUserCreate }
                edit={ AdminUserEdit }
                icon={ Person4 }
            />

            {/*  ADMIN ROLES - the ACL screen. HQ-API gates every operation on HQ_Admin::roles
                 or ROLE_OWNER, so a resource registered here is still refused server side. */}
            <Resource
                name="admin_roles"
                list={ AdminRoleList }
                create={ AdminRoleCreate }
                edit={ AdminRoleEdit }
                icon={ AdminPanelSettings }
            />

            {/*  Addresses */}
            <Resource
                name="addresses"
                list={ AdminAddressesList }
                edit={ AdminAddressEdit }
                show={ AdminAddressShow }
                create={ AdminAddressCreate }
                icon={ ContactMail }
            />

            {/*  COMPANIES */}
            { /* No `show`: the company Show screen was merged into its Edit on 2026-09-10 at
                 the user's instruction, and every company link in HQ now goes to the edit
                 screen. A `show` route with no component renders nothing, so it is gone
                 rather than left pointing at the merged screen. */ }
            <Resource
                name="companies"
                list={ AdminCompanyList }
                edit={ AdminCompanyEdit }
                create={ AdminCompanyCreate }
                icon={ Business }
            />

            {/*  COMPANIES HOUSE */}
            <Resource
                name="companies_houses"
                list={ AdminCompanyHouseList }
                edit={ AdminCompaniesHouseEdit }
                show={ AdminCompaniesHouseShow }
                create={ AdminCompaniesHouseCreate }
                icon={ LocationCity }
            />

            {/*  COMPANIES HOUSE ADDRESSES */}
            <Resource
                name="companies_house_addresses"
                list={ AdminCompaniesHouseAddressesList }
                edit={ AdminCompaniesHouseAddressEdit }
                show={ AdminCompaniesHouseAddressShow }
                create={ AdminCompaniesHouseAddressCreate }
                icon={ Apartment }
            />

            {/*  COMPANIES HOUSE FILINGS */}
            <Resource
                name="filing_histories"
                list={ AdminCompaniesHouseFilingHistoryList }
                edit={ AdminCompaniesHouseFilingHistoryEdit }
                create={ AdminCompaniesHouseFilingHistoryCreate }
                show={ AdminCompaniesHouseFilingHistoryShow }
                icon={ DocumentScanner }
            />

            {/* COMPANIES HOUSE PEOPLE */}
            <Resource
                name="companies_house_peoples"
                list={ AdminCompaniesHousePeopleList }
                edit={ AdminCompaniesHousePeopleEdit }
                show={ AdminCompaniesHousePeopleShow }
                create={ AdminCompaniesHousePeopleCreate }
                icon={ Group }
            />

            {/* EMAILS */}
            <Resource
                name="emails"
                list={ AdminEmailList }
                edit={ AdminEmailEdit }
                show={ AdminEmailShow }
                create={ AdminEmailCreate }
                icon={ Email }
            />

            {/*  EMPLOYEES */}
            <Resource
                name="employees"
                list={ AdminEmployeeList }
                edit={ AdminEmployeeEdit }
                show={ AdminEmployeeShow }
                create={ AdminEmployeeCreate }
                icon={ Badge }
            />

            {/*  CONTACTS */}
            <Resource
                name="contacts"
                list={ AdminPeopleList }
                create={ AdminPeopleCreate }
                edit={ AdminPeopleEdit }
                show={ AdminPeopleShow }
                icon={ EmojiPeople }
            />

            {/*  SOCIAL MEDIA */}
            <Resource
                name="social_media"
                list={ AdminSocialList }
                edit={ AdminSocialEdit }
                show={ AdminSocialShow }
                create={ AdminSocialCreate }
                icon={ Share }
            />

            {/*  TELEPHONES */}
            <Resource
                name="telephones"
                list={ AdminTelephoneList }
                edit={ AdminTelephoneEdit }
                show={ AdminTelephoneShow }
                create={ AdminTelephoneCreate }
                icon={ Phone }
            />

            {/*  URLS */}
            <Resource
                name="urls"
                list={ AdminUrlList }
                edit={ AdminUrlEdit }
                show={ AdminUrlShow }
                create={ AdminUrlCreate }
                icon={ Link }
            />

            {/*  WEBSITES */}
            <Resource
                name="websites"
                list={ AdminWebsiteList }
                edit={ AdminWebsiteEdit }
                show={ AdminWebsiteShow }
                icon={ Language }
            />

            {/*  OPERATORS */}
            <Resource
                name="operators"
                list={ OperatorList }
                create={ OperatorCreate }
                edit={ OperatorEdit }
            />

            {/*  WORKFLOWS */}
            <Resource
                name="workflows"
                list={ WorkflowList }
                create={ WorkflowCreate }
                edit={ WorkflowEdit }
            />

            {/*  TOOLS */}
            <Resource
                name="tools"
                list={ AdminAiSystemAgentToolList }
                create={ AdminAiSystemAgentToolCreate }
                edit={ AdminAiSystemAgentToolEdit }
            />

            { /*  PROMPTS */}
            <Resource
                name="prompts"
                list={ PromptList }
                create={ PromptCreate }
                edit={ PromptEdit }
            />

            { /* Model Schemas */ }
            <Resource
                name="model_schemas"
                list={ ModelSchemaList }
                edit={ ModelSchemaEdit }
                create={ ModelSchemaCreate }
            />

            { /* LLM Prices. What the dashboard's cost cards are worked out from. */ }
            <Resource
                name="llm_model_prices"
                list={ LlmModelPriceList }
                edit={ LlmModelPriceEdit }
                create={ LlmModelPriceCreate }
            />

            { /* Nok Websites */ }
            <Resource
                name="nok_websites"
                list={ NokWebsiteList }
                create={ NokWebsiteCreate }
                edit={ NokWebsiteEdit }
            />

            { /* Nok Personas */ }
            <Resource
                name="nok_personas"
                list={ NokPersonaList }
                create={ NokPersonaCreate }
                edit={ NokPersonaEdit }
            />

            { /* Settings */ }
            <Resource
                name="settings"
                list={ SettingsList }
                edit={ SettingsEdit }
                create={ SettingsCreate }
            />

            { /* Token History */ }
            <Resource
                name="token_histories"
                list={ TokenHistoryList }
            />

            { /* CMS Blocks */ }
            <Resource
                name="cms_blocks"
                list={ CmsBlockList }
                create={ CmsBlockCreate }
                edit={ CmsBlockEdit }
            />

            { /* Nok Email Signatures */ }
            <Resource
                name="nok_email_signatures"
                list={ NokEmailSignatureList }
                edit={ NokEmailSignatureEdit }
                create={ NokEmailSignatureCreate }
            />

            { /* Email Messages. The list and show are read only; the edit form stays registered
                 because the Mystery Shopper and Compliance Sniffer result screens link to it. */ }
            <Resource
                name="email_messages"
                list={ EmailMessagesList }
                show={ EmailMessagesShow }
                edit={ EmailMessagesEdit }
            />

            { /* Nok Mini */ }
            <Resource
                name="nok_minis"
                create={ NokMiniCreate }
                list={ NokMiniList }
                edit={ NokMiniEdit }
            />

            { /* Nok Email Templates */ }
            <Resource
                name="nok_email_templates"
                list={ NokEmailTemplateList }
                edit={ NokEmailTemplateEdit }
                create={ NokEmailTemplateCreate }
            />

            { /* Nok Email Metrics */ }
            <Resource
                name="email_metrics"
            />

            { /* Customer Accounts */ }
            <Resource
                name="customer_accounts"
                list={ CustomerAccountList }
                create={ CustomerAccountCreate }
                edit={ CustomerAccountEdit }
                icon={ SupervisorAccount }
            />

            { /* Customer Activity Monitor — read only: the API exposes no write operations */ }
            <Resource
                name="customer_activity_monitors"
                list={ CustomerActivityMonitorList }
                icon={ History }
                options={ { label: 'Account History' } }
            />

            { /* Customers */ }
            <Resource
                name="customers"
                list={ CustomerList }
                edit={ CustomerEdit }

                icon={ Person }
            />

            { /* Stripe Subscription Products */ }
            <Resource
                name="subscription_products"
                list={ SubscriptionProductList }
                create={ SubscriptionProductCreate }
                edit={ SubscriptionProductEdit }
            />

            { /* Stripe Subscription Product Prices */ }
            <Resource
                name="subscription_product_prices"
                list={ SubscriptionProductPriceList }
                create={ SubscriptionProductPriceCreate }
                edit={ SubscriptionProductPriceEdit }
            />

            { /* Subscription Invoice */ }
            <Resource
                name="subscription_invoices"
                list={ SubscriptionInvoiceList }
                show={ SubscriptionInvoiceShow }
            />

            { /* Subscription Invoice Items */ }
            <Resource
                name="subscription_invoice_items"
            />

            { /* Stripe Subscription */ }
            <Resource
                name="subscriptions"
                list={ SubscriptionList }
            />

            { /* Customer Addresses */ }
            <Resource
                name="customer_addresses"
                edit={ CustomerAddressEdit }
            />

            { /* Coupons */ }
            <Resource
                name="coupons"
                list={ CouponsList }
                create={ CouponCreate }
                show={ CouponShow }
            />

            { /* EmailFinder */ }
            <Resource
                name="email_finders"
                list={ EmailFinderList }
                edit={ EmailFinderEdit }
            />

            { /* EmailFinder Results */ }
            <Resource
                name="email_finder_results"
                list={ EmailFinderResultsList }
                edit={ EmailFinderResultsEdit }
            />

            { /* Enterprise Requests */ }
            <Resource
                name="enterprise_requests"
                list={ EnterpriseRequestsList }
                create={ EnterpriseRequestCreate }
                edit={ EnterpriseRequestEdit }
            />

            { /* Customer Tutorials */ }
            <Resource
                name="customer_tutorials"
                list={ CustomerTutorialList }
                create={ CustomerTutorialCreate }
                edit={ CustomerTutorialEdit }
            />

            { /* Contact Forms */ }
            <Resource
                name="contact_forms"
                list={ ContactFormList }
                edit={ ContactFormEdit }
            />

            { /* Sales Conversations — a home for the threads, which are worked from the record
                 they belong to. Read only: started by replying, never created here. */ }
            <Resource
                name="sales_conversations"
                list={ SalesConversationList }
            />

            { /* Mystery Shopper */ }
            <Resource name="mystery_shoppers"
                      list={ MysteryShopperList }
                      edit={ MysteryShopperEdit }
            />

            { /* Mystery Shopper Results*/ }
            <Resource name="mystery_shopper_results"
                      list={ MysteryShoppersResultsList }
                      edit={ MysteryShoppersResultsEdit }
            />
            { /*  Subscription Refunds */ }
            <Resource name="subscription_refunds"
                list={ SubscriptionRefundList }
                      show={ SubscriptionRefundShow }
            />
            { /* Compliance Sniffers */ }
            <Resource name='compliance_sniffers'
                      list={ ComplianceSnifferList }
                      edit={ ComplianceSnifferEdit }
                      />
            { /* Compliance Sniffer Results */ }
            <Resource name='compliance_sniffer_results'
                      list={ ComplianceSnifferResultsList }
                      edit={ ComplianceSnifferResultsEdit }
            />

            { /* Nok Processing Failures. No edit or create: rows are written by HQ-API's failure
                 paths and cleared by a rescore, and the API resource exposes no writes either. */ }
            <Resource name='nok_processing_failures'
                      list={ NokProcessingFailuresList }
                      icon={ ReportProblem }
            />

            { /* Noks */ }
            <Resource name="noks"
                      list={ NokList }
                      create={ NokCreate }
                      edit={ NokEdit  }
                      />

            { /* Mini Grades */ }
            <Resource name="mini_grades"
                      list={ MiniGradesList }
                      edit={ MiniGradeEdit  }
            />

            { /* Mini Results */ }
            <Resource name="mini_results"
                      list={ MiniResultsList }
                      edit={ MiniResultEdit  }
            />



        </Admin>
    );
}


export default AdminApp;